import React from "react";
import { Box, IconButton, Stack, TextField, Tooltip } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

import { NURSE_COLORS } from "../theme";

export default function DateRangeFilter({ dateFrom, dateTo, onChange }) {
  const handleFrom = (e) => onChange(e.target.value, dateTo);
  const handleTo = (e) => onChange(dateFrom, e.target.value);
  const handleClear = () => onChange("", "");

  const active = dateFrom || dateTo;

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        alignItems: "center",
        bgcolor: active ? "rgba(33,205,192,0.06)" : "transparent",
        borderRadius: 1.5,
        px: 1.5,
        py: 0.75,
        border: active ? `1px solid ${NURSE_COLORS.accent}40` : "1px solid transparent",
      }}
    >
      <TextField
        type="date"
        size="small"
        label="From"
        value={dateFrom}
        onChange={handleFrom}
        InputLabelProps={{ shrink: true }}
        sx={{ minWidth: 150 }}
      />
      <Box sx={{ color: "text.secondary", fontSize: 14 }}>—</Box>
      <TextField
        type="date"
        size="small"
        label="To"
        value={dateTo}
        onChange={handleTo}
        InputLabelProps={{ shrink: true }}
        sx={{ minWidth: 150 }}
      />
      {active && (
        <Tooltip title="Clear date filter">
          <IconButton size="small" onClick={handleClear} sx={{ color: "text.secondary" }}>
            <ClearIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  );
}
